import "../../styles/services.scss";
import React from "react";
import { ReactNode } from "react";
import { Title } from "../components/Title";
import { SubmenuTitle } from "../components/SubmenuTitle";
import { Search } from "../components/Search";
import { Pager } from "../components/Pager";
import { getVideos, VideoInfo } from "../../apis/api";
import { pageInfo } from "../../models/system";


export class Video extends React.Component {

    state = { data: null as pageInfo<VideoInfo> | null, curpage: 0, pagesize: 12 };
    async componentDidMount() {

        this.setState({ data: await getVideos(0, this.state.pagesize, 0) });

    }
    render(): ReactNode {
        return (
            <div className="video">

                <div className="videoitems">
                    {
                        this.state.data?.content?.map(x => (
                            <div>
                                <video src={x.url} controls></video>
                                <div className="videoTitle"> {x.title}
                                    <p>{x.address}/{x.date}</p> </div>
                            </div>
                        ))

                    }


                </div>
                <Pager pageCount={Math.ceil((this.state.data?.pageCount ?? 0) / this.state.pagesize)} pageSize={this.state.pagesize} curpage={0} onNavigatePage={(e) => {
                    this.setState({ curpage: e });
                    getVideos(e, this.state.pagesize, 0).then((data) => {
                        this.setState({ data });
                    })
                }}></Pager>
            </div>
        )
    }
}